// =========================================================
// Wyszukiwarka gabinetów („Gdzie kupić?”, blok acf/partner-finder)
// Formularz wraca na stronę z ?miasto=…#wyniki, ale po wysłaniu formularza Chrome nie przewija do kotwicy
// (przy wejściu z linku tak) — skok do wyników od razu i jeszcze raz po wczytaniu strony, chyba że użytkownik
// zaczął już przewijać. Bez animacji: html ma scroll-behavior: smooth, a płynne przewijanie przerywa odświeżenie
// ScrollTriggera przy „load”. Odstęp pod nagłówkiem: scroll-margin-top w CSS.
// =========================================================

function init() {
    const results = document.getElementById('wyniki');

    if ( ! results || ! results.classList.contains('partner-results') || window.location.hash !== '#wyniki') {
        return;
    }

    let userScrolled = false;
    ['wheel', 'touchmove', 'keydown'].forEach((type) => {
        window.addEventListener(type, () => (userScrolled = true), {once: true, passive: true});
    });

    const jump = () => {
        if (userScrolled) {
            return;
        }

        const root = document.documentElement;
        const behavior = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        results.scrollIntoView({block: 'start'});
        root.style.scrollBehavior = behavior;
    };

    jump();
    window.addEventListener('load', () => window.requestAnimationFrame(jump), {once: true});
}

export default {init};
